module.exports = __webpack_public_path__ + "img/图像 13.63b0a22d.png";